import { testFeature } from '@opallabs/principles'

export const approvalActions = {
  Delete: 'delete',
  Transfer: 'transfer',
}

export const shouldRenderContextMenu = (isPhaseActive, workflowLocation) =>
  workflowLocation !== 'workflowPopover' || isPhaseActive

export const shouldRenderInlineApproval = ({
  currentUser,
  isActive,
  proxyUser,
  status,
  toUser,
}) => {
  if (
    !testFeature('inline_workflow_approvals') ||
    !isActive ||
    status !== 'pending'
  )
    return false

  const approverId = proxyUser ? proxyUser.id : toUser.id
  return approverId === currentUser.id
}

export const getStatusDotStatus = ({ status }) => {
  switch (status) {
    case 'approved':
      return 'success'
    case 'denied':
      return 'error'
    case 'pending':
      return 'warning'
    case 'initial':
      return 'inactive'
    default:
      return 'inactive'
  }
}
